var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-select',{attrs:{"value-field":"id","value":_vm.selected,"options":_vm.overheadsurcharges},on:{"change":_vm.updateValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }